import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { MoveUpIcon } from '@skatteetaten/ds-icons';
import './styles.css';


const getVisibilityThresholdDefault = ()=>1;
const getScrollToMainDefault = ()=>true;

var styles = {
    "container": "ScrollToTopButton-module_container__lK0Kc",
    "scrollToTopButton": "ScrollToTopButton-module_scrollToTopButton__7kpu5",
    "scrollToTopButton_visible": "ScrollToTopButton-module_scrollToTopButton_visible__6FufN",
    "scrollToTopButtonIconContainer": "ScrollToTopButton-module_scrollToTopButtonIconContainer__izC8g",
    "scrollToTopButtonIconContainerIcon": "ScrollToTopButton-module_scrollToTopButtonIconContainerIcon__baclU",
    "scrollToTopButtonLabel": "ScrollToTopButton-module_scrollToTopButtonLabel__8GhDU"
};

const ScrollToTopButton = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), classNames, lang, 'data-testid': dataTestId, shadowRootNode, visibilityThreshold = getVisibilityThresholdDefault(), scrollToMain = getScrollToMainDefault(), children }, ref)=>{
    const [visible, setVisible] = useState(!visibilityThreshold);
    useEffect(()=>{
        const onScroll = ()=>{
            setVisible(window.scrollY >= visibilityThreshold);
        };
        window.addEventListener('scroll', onScroll);
        return ()=>window.removeEventListener('scroll', onScroll);
    }, [
        visibilityThreshold
    ]);
    const { t } = useTranslation('ds_buttons', {
        i18n: dsI18n
    });
    const buttonClassname = `${styles.scrollToTopButton} ${visible ? styles.scrollToTopButton_visible : ''} ${classNames?.button ?? ''}`.trim();
    const concatenatedClassName = `${styles.container} ${className} ${classNames?.container ?? ''}`.trim();
    return /*#__PURE__*/ jsx("div", {
        className: concatenatedClassName,
        children: /*#__PURE__*/ jsxs("button", {
            ref: ref,
            id: id,
            className: buttonClassname,
            lang: lang,
            type: 'button',
            "data-testid": dataTestId,
            onClick: ()=>{
                window.scrollTo(0, 0);
                const main = shadowRootNode ? shadowRootNode.querySelector('main') : document.querySelector('main');
                main?.focus({
                    preventScroll: !scrollToMain
                });
            },
            children: [
                /*#__PURE__*/ jsx("div", {
                    className: `${styles.scrollToTopButtonIconContainer} ${classNames?.iconContainer ?? ''}`.trim(),
                    children: /*#__PURE__*/ jsx(MoveUpIcon, {
                        size: 'large',
                        className: `${styles.scrollToTopButtonIconContainerIcon} ${classNames?.icon ?? ''}`.trim()
                    })
                }),
                /*#__PURE__*/ jsx("div", {
                    className: `${styles.scrollToTopButtonLabel} ${classNames?.label ?? ''}`.trim(),
                    children: children ? children : t('scrolltotopbutton.Title')
                })
            ]
        })
    });
});
ScrollToTopButton.displayName = 'ScrollToTopButton';

export { ScrollToTopButton, getScrollToMainDefault, getVisibilityThresholdDefault };
